// The chrome around a gallery: the app bar + the main content padding above and below it. The
// gallery is sized to `100vh - GALLERY_CHROME` so it and its pager sit inside the viewport with no
// page scroll.
export const GALLERY_CHROME = 112;
const PAGER = 52; // the Previous/Next row

// The least room the grid is ever given. On a viewport too short to hold the controls, a row and the
// pager, the gallery keeps this much and the rest is reached by scrolling — rather than the grid
// being squeezed to nothing under controls that always take their full height.
export const MIN_GALLERY_HEIGHT = 200;

// Decide how many columns and rows of cells fit the current viewport, and therefore how many items
// to fetch per page. Recomputed whenever the width (from AutoSizer) or the window height changes, so
// a resize refills the viewport exactly.
// availableHeight is the gallery's own height (e.g. the inner height of the card it sits in). When
// omitted the gallery fills the viewport (`100vh - GALLERY_CHROME`), the original behaviour.
export function galleryLayout(
  width: number,
  cellWidth: number,
  cellHeight: number,
  headerHeight = 0,
  availableHeight?: number,
) {
  const cols = Math.max(1, Math.floor(width / cellWidth));
  const gridHeight = Math.max(
    MIN_GALLERY_HEIGHT,
    (availableHeight ?? window.innerHeight - GALLERY_CHROME) - PAGER - headerHeight,
  );
  const rows = Math.max(1, Math.floor(gridHeight / cellHeight));
  return { cols, rows, perPage: cols * rows };
}
